var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntellectual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3178 8.59338L11.3278 14.2774C11.3391 14.3443 11.3298 14.4131 11.3009 14.4746C11.2721 14.536 11.2252 14.5872 11.1665 14.6212C11.1077 14.6553 11.04 14.6706 10.9724 14.6652C10.9047 14.6597 10.8403 14.6338 10.7878 14.5907L8.40117 12.7994C8.28595 12.7133 8.14599 12.6668 8.00217 12.6668C7.85835 12.6668 7.71838 12.7133 7.60317 12.7994L5.2125 14.5901C5.16005 14.633 5.09574 14.6589 5.02816 14.6644C4.96059 14.6699 4.89295 14.6546 4.83428 14.6206C4.7756 14.5867 4.72868 14.5356 4.69978 14.4743C4.67088 14.4129 4.66136 14.3443 4.6725 14.2774L5.68183 8.59338",
    stroke: "#00A651",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33337C10.2091 9.33337 12 7.54251 12 5.33337C12 3.12424 10.2091 1.33337 8 1.33337C5.79086 1.33337 4 3.12424 4 5.33337C4 7.54251 5.79086 9.33337 8 9.33337Z",
    stroke: "#00A651",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellectual);
export default __webpack_public_path__ + "static/media/Intellectual.6b695a6d549d3ace17f5c3c777897d8e.svg";
export { ForwardRef as ReactComponent };